import { render, staticRenderFns } from "./MultiValueCategorization.vue?vue&type=template&id=b85246aa&"
import script from "./MultiValueCategorization.vue?vue&type=script&lang=ts&"
export * from "./MultiValueCategorization.vue?vue&type=script&lang=ts&"
import style0 from "./MultiValueCategorization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports